module.exports = "https://trybtryb-legacy.web.app/img/mailchimp.25fdeec5.svg";